import React from 'react';
import { isUndefined } from 'lodash';
interface IconProps {
  icon: {
    iconPath: string;
    color?: string;
    width?: number;
    height?: number;
    iconExClass?: string;
  };
  background?: {
    bgShape: 'round' | 'square';
    className?: string;
    bgHeight?: number;
    bgWidth?: number;
    bgColor?: string;
  };
}

const Icon: React.FC<IconProps> = React.memo((props: IconProps) => {
  const {
    icon: { iconPath, color, width = 24, height = 24, iconExClass = '' },
    background
  } = props;

  let iconMask = {};
  iconMask = !isUndefined(color)
    ? {
        mask: `url(${iconPath}) no-repeat center / contain`,
        WebkitMask: `url(${iconPath}) no-repeat center / contain`
      }
    : {
        background: `url(${iconPath}) no-repeat center / contain`
      };

  let bgStyles = {};
  let bgClassName = '';
  if (!isUndefined(background)) {
    const { className, bgShape, bgHeight = 40, bgWidth = 40, bgColor } = background;
    const bgShapeStyle = bgShape === 'round' ? { borderRadius: `${bgHeight / 2}px` } : {};
    bgClassName = className;
    bgStyles = {
      width: `${bgWidth}px`,
      height: `${bgHeight}px`,
      backgroundColor: `${bgColor}`,
      display: `flex`,
      justifyContent: `center`,
      alignItems: `center`,
      ...bgShapeStyle
    };
  }

  return (
    <div style={bgStyles} className={bgClassName}>
      <div
        className={`svg-icon ${iconExClass}`}
        style={{
          width: `${width}px`,
          height: `${height}px`,
          backgroundColor: `${color}`,
          ...iconMask
        }}
      ></div>
    </div>
  );
});

Icon.displayName = 'Icon';

export { Icon, IconProps };
